module.exports = __webpack_public_path__ + "img/work_car.7498d46f.webp";